import { render, staticRenderFns } from "./grogshop.vue?vue&type=template&id=64953574&scoped=true"
import script from "./grogshop.vue?vue&type=script&lang=js"
export * from "./grogshop.vue?vue&type=script&lang=js"
import style0 from "./grogshop.vue?vue&type=style&index=0&id=64953574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64953574",
  null
  
)

export default component.exports